import React, { Fragment, useMemo, useRef, useState } from "react";
import './virtual-tour.scss';
import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";
import { VirtualTourPlugin } from "@photo-sphere-viewer/virtual-tour-plugin";
import "@photo-sphere-viewer/virtual-tour-plugin/index.css";
import "@photo-sphere-viewer/markers-plugin/index.css";
import VIT from './img/VIT.jpg';
import KIT from './img/KIT.jpg';
import Mil from './img/Mil.jpg';
import SIT from './img/SIT.jpg';
import VIT_thumb from './img/thumbs/VIT.jpg';
import KIT_thumb from './img/thumbs/KIT.jpg';
import Mil_thumb from './img/thumbs/Mil.jpg';
import SIT_thumb from './img/thumbs/SIT.jpg';
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import infoPng from './img/info.png';
import locationPng from './img/location.png';
import inPng from './img/in.png';
import { useLang } from "@ambiguous/useLang";
const tooltipsDefault = {
    "one": "Konteinerinis kranas pritaikytas krauti 20, 30, 40 ir 45 pėdų konteinerius ir puspriekabes iki 40 t.",
    "two": "Konteinerių laikymo vieta -1224 TEU + pasijungimas refrižeratoriniams konteineriams.",
    "three": "Automobilinės svarstyklės 40 t.",
    "four": "Konteinerių laikymo vieta (2500 kv.m.)",
    "five": "Talpa 726 euro paletės (1000 kv.m.)",
    "six": "Konteinerinis krautuvas 40 t. Terminalo traktorius –1 vnt",
    "eight": " Konteinerinis kranas ir krautuvas pritaikyti krauti 20, 30, 40 ir 45 pėdų konteinerius ir puspriekabes iki 40 t.Terminalo traktoriai – 2 vnt.",
    "nine": "Konteinerių laikymo vieta -855 TEU + pasijungimas refrižeratoriniams konteineriams.",
    "ten": " puspriekabių parkavimo aikštelė. Talpa – 60 puspriekabių",
    'thirteen': "Automobilinės svarstyklės 40 t.",
    'fourteen': "Konteinerinis kranas 20 t.",
    'fifteen': "aikštelė krovinių sandėliavimui (4500 kv.m.)",
    "nineteen": "Aikštelės krovinių sandėliavimui (9616 ir 8205 kv.m.)",
    "twenty": "Ožiniai kranai 8 ir 10 t. krovumo.",
    "twentyone": "Geležinkelio aukštakeliai biriems kroviniams iškrauti.",
    "twentytwo": 'Aikštelės krovinių sandėliavimui (4500, 7076 ir 5630 kv.m.)',
    'twentyfive': "Ožiniai kranai pritaikyti įvairių tipų krovinių ir konteinerių krovai. 20, 32 ir 41 t. krovumo",
    'twentysix': "Rampa tarp 1435 ir 1520 mm vėžės kelių. Rampos bendras plotas 2900 kv.m. rampos dalis po stogu 900 kv.m.",
    "SIT": "SIT – Šeštokų intermodalinis terminalas",
    "Mil": "Karinė/civilinė krovos aikštelė",
    'KIT': "KIT – Kauno intermodalinis terminalas",
    'VIT': "VIT – Vilniaus intermodalinis terminalas",
    "entry": "Įvažiavimas/išvažiavimas",
};
const switchView = (virtualTour, goto, setActive, tourNodes) => {
    const gotoView = tourNodes.find(({ id }) => id === goto);
    setActive(goto);
    return virtualTour.setCurrentNode(goto, {
        rotateTo: {
            pitch: gotoView.data.initialPitch,
            yaw: gotoView.data.initialYaw,
        }
    });
};
const thumbs = {
    VIT: VIT_thumb,
    KIT: KIT_thumb,
    Mil: Mil_thumb,
    SIT: SIT_thumb,
};
const views = {
    VIT: VIT,
    KIT: KIT,
    Mil: Mil,
    SIT: SIT,
};
export default function VirtualTourComponent({ visible, prefetch }) {
    const tooltips = (prefetch === null || prefetch === void 0 ? void 0 : prefetch.variables) || tooltipsDefault;
    const [showNav, setShowNav] = useState(true);
    //We need the instance of the component to apply plugins
    const instanceRef = useRef(null);
    //All plugins (can declare multiple)
    const plugins = [
        [VirtualTourPlugin, { renderMode: "3d" }],
        [MarkersPlugin]
    ];
    const tourNodes = useMemo(() => {
        const arr = [...tourNodesDefault((prefetch === null || prefetch === void 0 ? void 0 : prefetch.variables) || tooltipsDefault)];
        // const arr = [...tourNodesDefault(prefetch?.variables || tooltipsDefault)];
        if (visible.length === 0)
            return arr;
        const index = arr.findIndex(item => item.id === visible[0]);
        if (index !== -1) {
            const [targetItem] = arr.splice(index, 1); // Remove the target item
            arr.unshift(targetItem); // Add it to the start of the array
        }
        return arr;
    }, [visible, prefetch === null || prefetch === void 0 ? void 0 : prefetch.variables]);
    //Function that instantiates plugin and data to it
    const handleReady = (instance) => {
        instanceRef.current = instance;
        // (window as any).ltgVirtualTour = instance;
        const virtualTour = instanceRef.current.getPlugin(VirtualTourPlugin);
        const markers = instanceRef.current.getPlugin(MarkersPlugin);
        markers.addEventListener("select-marker", ({ marker }) => {
            var _a, _b;
            const polygon = (_a = marker.data) === null || _a === void 0 ? void 0 : _a.polygon;
            const goto = (_b = marker.data) === null || _b === void 0 ? void 0 : _b.goto;
            const allMarkers = markers.getMarkers();
            const polygons = allMarkers.filter(({ isPoly }) => isPoly());
            let clickedPolygons = typeof polygon === 'string' ? [polygon] : [...(polygon || [])];
            polygons.map(({ id }) => {
                !clickedPolygons.includes(id) && markers.hideMarker(id);
            });
            switch (true) {
                case (!!polygon):
                    if (typeof polygon === 'string') {
                        markers.toggleMarker(polygon);
                    }
                    else {
                        polygon.map((id) => { markers.toggleMarker(id); });
                    }
                    break;
                case (!!goto):
                    switchView(virtualTour, goto, setActive, tourNodes);
                    break;
            }
        });
        virtualTour.setNodes(tourNodes);
    };
    const [lang] = useLang();
    const tourRef = useRef();
    const [active, setActive] = useState();
    return (React.createElement("div", { className: "ltg-virtual-tour", ref: tourRef },
        visible.length > 1 && React.createElement(React.Fragment, null,
            React.createElement("div", { className: `ltg-virtual-tour-nav${showNav ? '' : ' --hide'}`, tabIndex: showNav ? undefined : -1 },
                React.createElement("div", { className: "ltg-virtual-tour-list" }, visible.map((id) => {
                    return React.createElement(Fragment, { key: id },
                        React.createElement("button", { className: `ltg-virtual-tour-link${id === active ? ' --active' : ''}`, onClick: (ev) => {
                                ev.preventDefault();
                                const vtour = instanceRef.current.getPlugin(VirtualTourPlugin);
                                switchView(vtour, id, setActive, tourNodes);
                                setShowNav(false);
                            } },
                            React.createElement("img", { className: "ltg-virtual-tour-thumb", src: thumbs[id], alt: tooltips[id] }),
                            tooltips[id]));
                })))),
        visible.length === 0 ? React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "text-center" }, "Nepa\u017Eym\u0117tas nei vienas terminalas")) : React.createElement(React.Fragment, null,
            React.createElement(ReactPhotoSphereViewer, { src: views[visible[0]], plugins: plugins, height: "100%", width: "100%", onReady: handleReady, loadingTxt: lang === 'lt' ? "Kraunasi" : undefined, navbar: false, defaultPitch: tourNodes[0].data.initialPitch, defaultYaw: tourNodes[0].data.initialYaw, 
                // onPositionChange={(pitch,yaw)=>{
                //     console.log({pitch,yaw});
                // }}
                onClick: (data) => {
                    // console.log([+data.data.yaw.toFixed(3),+data.data.pitch.toFixed(3),]);
                    const plugin = instanceRef.current.getPlugin(MarkersPlugin);
                    const allMarkers = plugin.getMarkers();
                    allMarkers.map(({ id, isPoly }) => {
                        if (isPoly()) {
                            plugin.hideMarker(id);
                        }
                    });
                } })),
        visible.length > 1 && React.createElement(React.Fragment, null,
            React.createElement("button", { className: "ltg-virtual-tour-nav-toggle", onClick: () => {
                    setShowNav(o => !o);
                } }, "Meniu")),
        React.createElement("button", { "aria-label": "Full screen", className: "ltg-virtual-tour-fs", onClick: () => {
                if (!document.fullscreenElement) {
                    tourRef.current.requestFullscreen()
                        .catch(err => console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`));
                }
                else {
                    document.exitFullscreen();
                }
            } },
            React.createElement("i", { className: "fas fa-expand" }))));
}
const entryMarker = (id, pitch, yaw, tooltips) => {
    return {
        id,
        position: { pitch, yaw },
        size: { width: 32, height: 32 },
        tooltip: {
            content: tooltips.entry,
            trigger: 'click'
        },
        image: inPng,
        anchor: 'center bottom',
    };
};
const infoMarker = (id, pitch, yaw, tooltips, polygon) => {
    return {
        id,
        data: {
            polygon
        },
        position: { yaw, pitch },
        image: infoPng,
        size: { width: 32, height: 32 },
        tooltip: tooltips[id] ? {
            content: tooltips[id],
            trigger: 'click'
        } : undefined,
        hoverScale: polygon ? 1.1 : undefined,
    };
};
const locationMarker = (id, pitch, yaw, tooltip) => {
    return {
        id,
        data: {
            goto: id
        },
        position: { yaw, pitch },
        image: locationPng,
        size: { width: 64, height: 64 },
        tooltip,
        anchor: 'center bottom',
        style: {
            filter: 'drop-shadow(0 0 2px rgba(0,0,0,.5))'
        }
    };
};
const polygonMarker = (id, polygon, tooltip) => {
    const poly = {
        id,
        polygon,
        svgStyle: {
            fill: 'rgba(0, 199, 73, 0.2)',
            stroke: 'rgba(0, 199, 73, 0.8)',
            strokeWidth: '2px',
        },
        visible: false
    };
    if (tooltip) {
        poly['tooltip'] = {
            content: tooltip,
            position: 'bottom right',
        };
    }
    return poly;
};
const tourNodesDefault = (tooltips) => [
    {
        id: "VIT",
        panorama: VIT,
        name: tooltips.VIT,
        data: {
            initialPitch: -0.6,
            initialYaw: 5.4,
        },
        markers: [
            infoMarker("one", -0.42, 5.2, tooltips),
            infoMarker("two", -.78, 5.55, tooltips, "polygon-two"),
            polygonMarker("polygon-two", [
                [4.73120857468539, -0.15855531367550113],
                [4.779881811690573, -0.1605174556677107],
                [0.918791321804478, -0.5096071262930204],
                [1.1452658128725544, -0.5521735990429697]
            ], tooltips.two),
            infoMarker("three", -.7, 1.72, tooltips),
            infoMarker("four", -.94, 1.27, tooltips, "polygon-four"),
            polygonMarker("polygon-four", [
                [1.093, -0.738],
                [1.695, -0.783],
                [2.239, -0.954],
                [0.826, -0.989],
            ], tooltips.four),
            infoMarker("five", -1.5, 4, tooltips),
            infoMarker("six", -1.1, 3, tooltips),
            locationMarker('KIT', 0, 4.42, tooltips.KIT),
            locationMarker('SIT', 0, 3.42, tooltips.SIT),
            entryMarker('entry', -0.508, 2.836, tooltips)
        ]
        // links: [{ nodeId: "2", position: { textureX: 100, textureY: 1800 } }],
        // defaultZoomLvl: 0,
    },
    {
        id: "SIT",
        panorama: SIT,
        name: tooltips.SIT,
        data: {
            initialPitch: -.362,
            initialYaw: 6.171,
        },
        markers: [
            locationMarker('KIT', 0, 6.05, tooltips.KIT),
            locationMarker('VIT', 0, .537, tooltips.VIT),
            entryMarker('entry', -.073, 6.223, tooltips),
            entryMarker('entry2', -.64, .522, tooltips),
            infoMarker('twentyfive', -.232, 0.059, tooltips),
            infoMarker('twentysix', -.457, 0.133, tooltips, 'polygon-twentysix'),
            polygonMarker('polygon-twentysix', [
                [6.214, -0.112],
                [6.227, -0.114],
                [0.251, -0.567],
                [0.174, -0.581],
            ], tooltips.twentysix)
        ]
    },
    {
        id: 'Mil',
        panorama: Mil,
        name: tooltips.Mil,
        data: {
            initialPitch: -.367,
            initialYaw: 3.271,
        },
        markers: [
            locationMarker('VIT', 0, 1.662, tooltips.VIT),
            locationMarker('KIT', -.141, 1.307, tooltips.KIT),
            locationMarker('SIT', 0, 3.184, tooltips.SIT),
            infoMarker('nineteen', -.286, 2.938, tooltips, ['polygon-nineteen-1', 'polygon-nineteen-2']),
            infoMarker('twenty', -.383, 3.39, tooltips),
            polygonMarker('polygon-nineteen-1', [
                [2.878, -0.168],
                [2.987, -0.166],
                [3.047, -0.34],
                [3.007, -0.342],
                [3.09, -0.629],
                [2.982, -0.621],
                [2.877, -0.368],
                [2.834, -0.31],
                [2.88, -0.169],
            ], "8205 m²"),
            polygonMarker('polygon-nineteen-2', [
                [3.017, -0.144],
                [3.091, -0.141],
                [3.694, -0.557],
                [3.348, -0.643],
            ], "9616 m²"),
            infoMarker('twentyone', -.884, 5.421, tooltips),
            infoMarker('twentytwo', -.709, 6.051, tooltips, ['polygon-twentytwo-1', 'polygon-twentytwo-2', 'polygon-twentytwo-3']),
            entryMarker('entry', -.128, .819, tooltips),
            polygonMarker('polygon-twentytwo-1', [
                [5.558, -0.347],
                [5.675, -0.353],
                [3.73, -1.148],
                [3.932, -0.854],
            ], "4500 m²"),
            polygonMarker('polygon-twentytwo-2', [
                [5.742, -0.35],
                [6.221, -0.31],
                [2.167, -1.24],
                [3.542, -1.263],
            ], "7076 m²"),
            polygonMarker('polygon-twentytwo-3', [
                [0.005, -0.298],
                [0.197, -0.251],
                [0.363, -0.291],
                [0.307, -0.338],
                [0.439, -0.597],
                [1.253, -1.014],
                [1.937, -1.163],
            ], "5630 m²"),
        ]
    },
    {
        id: 'KIT',
        panorama: KIT,
        name: tooltips.KIT,
        data: {
            initialPitch: -.646,
            initialYaw: 5.182,
        },
        markers: [
            locationMarker('VIT', 0, 4.81, tooltips.VIT),
            infoMarker('eight', -.299, 4.918, tooltips),
            infoMarker('nine', -.43, 5.355, tooltips, "polygon-nine"),
            polygonMarker('polygon-nine', [
                [6.158, -0.21],
                [6.236, -0.227],
                [4.085, -0.273],
                [4.149, -0.263],
            ], tooltips.nine),
            infoMarker('ten', -.646, 5.929, tooltips, 'polygon-ten'),
            polygonMarker('polygon-ten', [
                [0.01, -0.218],
                [0.084, -0.222],
                [0.02, -0.361],
                [5.921, -1.212],
                [5.094, -0.83],
                [5.089, -0.58],
            ], tooltips.ten),
            entryMarker('entry', -1.078, 4.824, tooltips),
            entryMarker('entry2', -.152, 6.221, tooltips),
            locationMarker('SIT', 0, .112, tooltips.SIT),
            locationMarker('Mil', -0.109, .807, tooltips.Mil),
            infoMarker('thirteen', -.246, .563, tooltips),
            infoMarker('fourteen', -.444, .522, tooltips),
            infoMarker('fifteen', -.78, 1.145, tooltips, "polygon-fifteen"),
            polygonMarker('polygon-fifteen', [
                [0.335, -0.299],
                [0.239, -0.304],
                [2.618, -0.558],
                [2.419, -0.501],
            ], tooltips.fifteen),
        ]
    },
];
